import BaseUtil from "../../util/BaseUtil";

const type = `@@ActionType/UPDATE@${__filename}`;

export const DISPLAY_MODE = {
    DISTRICT: "DISTRICT",
    HOSPITAL: "HOSPITAL",
};


const initState = {
    selectedDistricts: ["ALL"],
    selectedHospitalTypes: ["ALL"],
    pageable: {
        current: 1,
        limit: 20,
    },
};

const [viewModel, update, reset] = BaseUtil.getViewModel(initState, type);

export {

    update,
    reset,
};
export default viewModel;
